<template>
  <div>
    <v-card
      class="mx-auto mt-10"
      max-width="1600"
      tile
    >
      <v-list-item v-for="(list, index) in lists"
        :key="list.id"
        :to="list.to"
        two-line
        :style="{ backgroundColor: rowBackground(index) }"
      >
        <v-list-item-content>
          <v-list-item-title>{{list.caption}}</v-list-item-title>
          <v-list-item-subtitle>{{list.description}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Profile',
  components: {
  },
  data: () => ({
    lists: [
      {
        id: 1, to: { path: '/profile/settings' }, caption: 'Profile Settings', description: 'Manage user-specific UX settings, password, etc.',
      },
      {
        id: 2, to: { path: '/profile/webauthn' }, caption: 'User Passwordless Registration', description: '(BETA) Setup passwordless sign-in.',
      },
      {
        id: 3, to: { path: '/profile/wkst' }, caption: 'WKST Profile', description: 'Manage work station number.',
      },
      {
        id: 4, to: { path: '/profile/printer-settings' }, caption: 'Printer Settings', description: 'Manage printer options.',
      },
    ],
  }),
  computed: {
    ...mapGetters('user', ['getSettings']),
  },
  methods: {
    rowBackground(index) {
      const isDark = this.getSettings.lightdark === 'dark';
      const isEven = index % 2 === 0;
      if (isDark) {
        return isEven ? '#5c5c5c' : '#424242';
      }
      return isEven ? '#c9c7f0' : 'white';
    },
  },
};
</script>
